import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBXbnn4F-G5m-622YmWj_J4lhQIaQiiNaE",
  authDomain: "build-connect-908d1.firebaseapp.com",
  projectId: "build-connect-908d1",
  storageBucket: "build-connect-908d1.firebasestorage.app",
  messagingSenderId: "173623392082",
  appId: "1:173623392082:web:bc0845fc94d71da7bb2c8b",
  measurementId: "G-F87M2B9RTN"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
